import React from "react";
import { Link } from "react-router-dom";
import { Wind, ArrowRight } from "lucide-react";

export const SomaticResetStrip = () => (
  <Link to="/somatic-reset" data-testid="home-somatic-reset-strip"
    className="group block overflow-hidden rounded-2xl bg-ivory-50 p-6 text-left ring-1 ring-ivory-400/60 transition hover:ring-gold/40 sm:p-7">
    <div className="flex items-center gap-5">
      <span className="flex-none inline-flex h-12 w-12 items-center justify-center rounded-full bg-gold/10 text-gold-deep">
        <Wind strokeWidth={1.5} className="h-5 w-5" />
      </span>
      <div className="min-w-0">
        <p className="kicker text-gold-foil">Free · A body-first reset</p>
        <p className="mt-1 font-display text-xl text-ink">The 1-Minute Somatic Reset Guide</p>
        <p className="mt-1 text-sm leading-relaxed text-ink-soft">
          Notice where you're bracing, soften what you can — a free pocket guide, instant download.
        </p>
      </div>
      <ArrowRight className="ml-auto hidden h-5 w-5 flex-none text-gold-deep transition group-hover:translate-x-1 sm:block" />
    </div>
  </Link>
);
